export default {
  scrapingTypes: {
    keywordsProgress: 0,
    linkProgress: 1,
    cacheGenerator: 2,
    domainCacheGenerator: 3
  },
  user_steps: {
    first_project: {
      id: 1,
      name: 'Create your first project',
      hint: ''
    },
    keywords: {
      id: 2,
      // to your projects to know if they were affected by Google updates
      name: 'Add at least 100 ranking keywords',
      hint: ''
    },
    cannibalization_problems: {
      id: 3,
      name: 'Check and fix content cannibalization problem in your projects',
      hint: ''
    },
    predicted_traffic: {
      id: 4,
      name: 'Check the predicted traffic for your sites',
      hint: ''
    },
    niche_finder: {
      id: 5,
      name: 'Improve your pages’ title, meta tags & content',
      hint: ''
    },
    distribution_graph: {
      id: 6,
      name: 'Check your keywords count/ searches volume increase over time',
      hint: ''
    },
    niche_competition: {
      id: 7,
      name: 'Do a market research',
      hint: ''
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/dashboard/state.js